(function($) {
  const tableSections = Array.from(document.querySelectorAll(".content-text-table"));

  /**
   * @description - This function sets min-height of section to it's absolute element to be sure that it's never smaller
   */
  const tableSectionHeight = () => {
    tableSections.forEach(item => {
      const tableHeight = $(tableSections)
        .find(".table")
        .height();

      item.setAttribute("style", `min-height: ${tableHeight + 100}px;`);
    });
  };

  $(document).ready(() => {
    tableSectionHeight();
  });

  $(window).on("resize", () => {
    tableSectionHeight();
  });
})(jQuery);
